<template>
  <div class="admin">
    <div class="login-block">
      <div class="col-3">
        <el-card>
          <div class="card-title fs-4 pb-3">
            Регистрация админа
          </div>
          <el-form
            size="large"
            ref="form"
            :model="form"
            class="text-start"
            status-icon
            label-width="auto">

            <el-form-item prop="name"
                          :rules="[{ required: true, message: 'Обязательно для заполнение'}]">
              <el-input :prefix-icon="UserFilled" placeholder="ФИО" v-model="form.name" type="text"
                        autocomplete="off" />
            </el-form-item>

            <el-form-item prop="email"
                          :rules="[
        {
          required: true,
          message: 'Введите адрес электронной почты',
          trigger: 'blur',
        },
        {
          type: 'email',
          message: 'Введите правильный адрес электронной почты.',
          trigger: ['blur', 'change'],
        },
      ]">
              <el-input :prefix-icon="Message" placeholder="E-mail" v-model="form.email" type="text"
                        autocomplete="off" />
            </el-form-item>

            <el-form-item prop="password"
                          :rules="[{ required: true, message: 'Обязательно для заполнение'}]">
              <el-input :prefix-icon="More" placeholder="Password" v-model="form.password" type="password"
                        autocomplete="off" show-password />
            </el-form-item>

            <el-form-item prop="super"
                          :rules="[{ required: true, message: 'Обязательно для заполнение'}]">
              <el-input :prefix-icon="More" placeholder="Super password" v-model="form.super" type="password"
                        autocomplete="off" show-password />
            </el-form-item>

            <el-form-item>
              <div class="w-100 text-end">
                <el-button type="success" :loading="isLoading" @click="registration">Зарегистрировать админа</el-button>
              </div>
            </el-form-item>

          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Message, More, UserFilled } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import store from '@/components/store/store'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Admin',
  computed: {
    UserFilled() {
      return UserFilled
    },
    More() {
      return More
    },
    Message() {
      return Message
    }
  },
  data() {
    return {
      form: {},
      isLoading: false
    }
  },
  methods: {
    async registration() {
      this.isLoading = true
      try {
        await this.$refs.form.validate()
      } catch (e) {
        ElMessage.error('Заполните необходимые поля')
        this.isLoading = false
        return
      }
      await store.dispatch('auth/registrationAdmin', { form: this.form })
      this.isLoading = false;
      this.form = {};
    }
  }
}
</script>
<style scoped>
.admin {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-block {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>